import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { LOC_ATTACHMENTS, LOC_MESSAGE } from "../../../../../../locKeys";
import { SendMailPageComponent, SendMailPageComponentProps } from "./SendMailPageComponent";

type StateProps = Pick<SendMailPageComponentProps, "messageText" | "attachmentsText">;

const mapStateToProps: MapStateToProps<StateProps, NoneOwnProps, IAppState> = (state) => ({
    messageText: getPrimaryText(state, LOC_MESSAGE) ?? "Zpráva",
    attachmentsText: getPrimaryText(state, LOC_ATTACHMENTS) ?? "Přílohy",
});

export const SendMailPage = connect(mapStateToProps)(SendMailPageComponent);
